export const LorenNotificationResolverConstant = {
    NOTIFICATION: 'notification'
};
